import { render, staticRenderFns } from "./DocumentAdditionalInfo.vue?vue&type=template&id=23592934"
import script from "./DocumentAdditionalInfo.vue?vue&type=script&lang=js"
export * from "./DocumentAdditionalInfo.vue?vue&type=script&lang=js"
import style0 from "./DocumentAdditionalInfo.vue?vue&type=style&index=0&id=23592934&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports